import { 
  Package, 
  Users, 
  BookOpen, 
  ShieldCheck, 
  ArrowUpRight, 
  Sparkles,
  Layers
} from 'lucide-react';
import { EXECUTIVE_KPIS } from './executive-data.js';
import { cn } from '../../lib/utils.js';

const KPI_ICON_MAP = {
  Package,
  Users,
  BookOpen,
  ShieldCheck,
  Layers,
};

export function ExecutiveKpiStrip({
  kpis = EXECUTIVE_KPIS,
  className,
  onKpiClick,
}) {
  return (
    <div 
      data-testid="executive-kpi-strip"
      className={cn('grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4', className)}
    >
      {kpis.map((kpi) => {
        const Icon = (typeof kpi.icon === 'string' ? KPI_ICON_MAP[kpi.icon] : kpi.icon) || Package;

        return (
          <div
            key={kpi.id}
            data-testid={`kpi-card-${kpi.id}`}
            onClick={() => onKpiClick && onKpiClick(kpi)}
            className="group relative flex flex-col justify-between rounded-2xl border border-slate-200 bg-white p-5 shadow-xs transition-all duration-200 hover:-translate-y-0.5 hover:border-[var(--primary,#e3000b)] hover:shadow-sm cursor-pointer"
          >
            {/* Top Accent Line on hover */}
            <div className="absolute inset-x-0 top-0 h-1 rounded-t-2xl bg-transparent group-hover:bg-[var(--primary,#e3000b)] transition-colors" />

            <div>
              {/* Category & Icon */}
              <div className="flex items-center justify-between gap-2">
                <span className="text-[11px] font-bold uppercase tracking-wider text-slate-500">
                  {kpi.category || kpi.title}
                </span>
                <div className="flex h-9 w-9 items-center justify-center rounded-xl bg-slate-50 text-[var(--primary,#e3000b)] border border-slate-200 group-hover:bg-[var(--primary)] group-hover:text-white transition-colors">
                  <Icon className="h-4 w-4" />
                </div>
              </div>

              {/* Title & Metric Value */}
              <div className="mt-3">
                <h3 className="text-xs font-medium text-slate-600">
                  {kpi.title}
                </h3>
                <p className="mt-1 font-display text-2xl font-extrabold tracking-tight text-slate-900 tabular-nums">
                  {kpi.value}
                </p>
              </div>
            </div>

            {/* Bottom Status / Change Badge */}
            <div className="mt-4 pt-3 border-t border-slate-100 flex items-center justify-between gap-2 text-xs">
              <span className="inline-flex items-center gap-1 font-bold text-emerald-800 bg-emerald-50 px-2 py-0.5 rounded-md border border-emerald-200 text-[11px] tabular-nums">
                <ArrowUpRight className="h-3 w-3" />
                {kpi.change}
              </span>
              {kpi.subtext && (
                <span className="text-[11px] text-slate-500 truncate max-w-[140px]" title={kpi.subtext}>
                  {kpi.subtext}
                </span>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}
